import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import styles from './Layout.module.css';

type LayoutProps = {
  activeItem: string;
  onNavigate: (id: string) => void;
  children: React.ReactNode;
};

function Layout({ activeItem, onNavigate, children }: LayoutProps): React.ReactElement {
  return (
    <div className={styles.layout}>
      <Header />
      <div className={styles.body}>
        <Sidebar activeItem={activeItem} onNavigate={onNavigate} />
        <main className={styles.main}>{children}</main>
      </div>
    </div>
  );
}

export default Layout;
